import { useMemo } from 'react';
import { mapToChartContract } from './chart';
import { ChartProps, EPriceType, ETime } from './chart.component';

const useChartData = (
    historic: ChartProps['historic'],
    priceType: EPriceType,
    time: ETime,
    isVehicle0km: boolean,
    isVehicleArmored: boolean,
) => {
    return useMemo(() => {
        const source =
            priceType === EPriceType.webmotors
                ? isVehicleArmored
                    ? historic?.wm_average?.armored
                    : historic?.wm_average?.not_armored
                : isVehicle0km
                  ? historic?.fipe?.new
                  : historic?.fipe?.used;

        return { data: mapToChartContract(source, time), source };
    }, [historic, time, priceType, isVehicleArmored, isVehicle0km]);
};

export default useChartData;
